/* eslint-disable no-undef */
import { format } from "date-fns";
import uniqueId from "../utils/generateId";
import Mock from "./mock";
export const tableData1 = [
  {
    id: uniqueId(),
    avatar: "/static/avatar/001-man.svg",
    name: "Zachary Gomez",
    username: "zachary-gomez",
    email: "zachary-gomez@gmail.com",
    role: "Editor",
  },
  {
    id: uniqueId(),
    avatar: "/static/avatar/002-girl.svg",
    name: "Amanda Montgomery",
    username: "amanda-montgomery",
    email: "montgomery@ya.com",
    role: "Subscriber",
  },
  {
    id: uniqueId(),
    avatar: "/static/avatar/003-boy.svg",
    name: "Lester Holland",
    username: "lester-holland",
    email: "lester75@gmail.com",
    role: "Subscriber",
  },
  {
    id: uniqueId(),
    avatar: "/static/avatar/004-woman.svg",
    name: "Max Allison",
    username: "max-allison",
    email: "max-allison@pochta.io",
    role: "Subscriber",
  },
  {
    id: uniqueId(),
    avatar: "/static/avatar/005-man-1.svg",
    name: "Richard Gregory",
    username: "r.gregory",
    email: "gregory@gmail.com",
    role: "Subscriber",
  },
  {
    id: uniqueId(),
    avatar: "/static/avatar/006-woman-1.svg",
    name: "Clifford Caldwell",
    username: "clifford-caldwell",
    email: "clifford-c@gmail.com",
    role: "Author",
  },
  {
    id: uniqueId(),
    avatar: "/static/avatar/007-boy-1.svg",
    name: "Lester Holland",
    username: "zlester-holland",
    email: "lester75@gmail.com",
    role: "Subscriber",
  },
  {
    id: uniqueId(),
    avatar: "/static/avatar/008-clown.svg",
    name: "Richard Gregory",
    username: "r.gregory",
    email: "gregory@gmail.com",
    role: "Subscriber",
  },
  {
    id: uniqueId(),
    avatar: "/static/avatar/009-firefighter.svg",
    name: "Max Allison",
    username: "max-allison",
    email: "max-allison@pochta.io",
    role: "Subscriber",
  },
  {
    id: uniqueId(),
    avatar: "/static/avatar/010-girl-1.svg",
    name: "Zachary Gomez",
    username: "zachary-gomez",
    email: "zachary-gomez@gmail.com",
    role: "Editor",
  },
  {
    id: uniqueId(),
    avatar: "/static/avatar/011-man-2.svg",
    name: "Zachary Gomez",
    username: "zachary-gomez",
    email: "zachary-gomez@gmail.com",
    role: "Editor",
  },
  {
    id: uniqueId(),
    avatar: "/static/avatar/012-woman-2.svg",
    name: "Zachary Gomez",
    username: "zachary-gomez",
    email: "zachary-gomez@gmail.com",
    role: "Editor",
  },
];
Mock.onGet("/api/tableData1/all").reply(() => {
  return [200, tableData1];
});
Mock.onPost("/api/tableData1/new").reply((config) => {
  const { name, username, email, role } = JSON.parse(config.data);
  const newData = {
    role,
    name,
    email,
    username,
    id: uniqueId(),
    avatar: "/static/avatar/012-woman-2.svg",
  };
  tableData1.push(newData);
  return [200, tableData1];
});
Mock.onPost("/api/tableData1/delete").reply((config) => {
  const { ids } = JSON.parse(config.data);
  const filterTable = tableData1.filter(
    (data, index) => data.id !== ids[index]
  );
  return [200, filterTable];
}); // ============================================================

const dateOfBirth = format(new Date(2021, 11, 2), "MMM dd, yyyy");
const lastCalledDate = format(new Date(2024, 6, 5), "MMM dd, yyyy");
const joinDate = format(new Date(2023, 7, 20), "MMM dd, yyyy");
const nextPaymentDate = format(new Date(2023, 8, 20), "MMM dd, yyyy");
const shippingProcessDate = format(new Date(2023, 8, 10), "MMM dd, yyyy");

export const tableData2 = [
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Designer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/001-man.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Callins",
    position: "Editor",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/002-girl.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Designer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/003-boy.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Developer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/004-woman.svg",
    dateOfBirth: format(new Date(2021, 10, 5), "MMM dd, yyyy"),
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Developer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/005-man-1.svg",
    dateOfBirth: format(new Date(2021, 10, 5), "MMM dd, yyyy"),
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Designer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/001-man.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Callins",
    position: "Editor",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/002-girl.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Designer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/003-boy.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Developer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/004-woman.svg",
    dateOfBirth: format(new Date(2021, 10, 5), "MMM dd, yyyy"),
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Developer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/005-man-1.svg",
    dateOfBirth: format(new Date(2021, 10, 5), "MMM dd, yyyy"),
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Designer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/001-man.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Callins",
    position: "Editor",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/002-girl.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Designer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/003-boy.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Developer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/004-woman.svg",
    dateOfBirth: format(new Date(2021, 10, 5), "MMM dd, yyyy"),
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Developer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/005-man-1.svg",
    dateOfBirth: format(new Date(2021, 10, 5), "MMM dd, yyyy"),
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
];

export const apiData = [
  {
    id: uniqueId(),
    name: "사용자 API",
    position: "Designer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    lastCalledDate,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "정상",
    endpoint: "/api/users",
    lastChecked: "5분전",
    responseTime: "200ms",
  },
  {
    id: uniqueId(),
    name: "인증 API",
    position: "Editor",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    lastCalledDate,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "정상",
    endpoint: "/api/auth",
    lastChecked: "1분전",
    responseTime: "150ms",
  },
  {
    id: uniqueId(),
    name: "제품 API",
    position: "Designer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    lastCalledDate,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "연체",
    endpoint: "/api/products",
    lastChecked: "5분전",
    responseTime: "N/A",
  },
  {
    id: uniqueId(),
    name: "주문 API",
    position: "Developer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    lastCalledDate,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "정상",
    endpoint: "/api/orders",
    lastChecked: "1분전",
    responseTime: "180ms",
  },
  {
    id: uniqueId(),
    name: "사용자 API",
    position: "Developer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    lastCalledDate,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "정상",
    endpoint: "/api/users",
    lastChecked: "5분전",
    responseTime: "220ms",
  },
  {
    id: uniqueId(),
    name: "인증 API",
    position: "Designer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    lastCalledDate,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "연체",
    endpoint: "/api/auth",
    lastChecked: "1분전",
    responseTime: "N/A",
  },
  {
    id: uniqueId(),
    name: "제품 API",
    position: "Editor",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    lastCalledDate,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "정상",
    endpoint: "/api/products",
    lastChecked: "5분전",
    responseTime: "190ms",
  },
  {
    id: uniqueId(),
    name: "주문 API",
    position: "Designer",
    team: 15,
    experience: "3 years",
    phone: "+00578115245",
    lastCalledDate,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "정상",
    endpoint: "/api/orders",
    lastChecked: "1분전",
    responseTime: "170ms",
  },
];

export const userPaymentData = [
  {
    id: uniqueId(),
    name: "김철수",
    email: "chulsoo.kim@example.com",
    joinDate,
    paymentStatus: "정상",
    paymentAmount: 50000,
    nextPaymentDate,
    memberGrade: "프리미엄",
    address: "서울시 강남구",
    avatar: "/static/avatar/001-man.svg",
    productOrderNumber: "2024071155576771",
    orderNumber: "2024071155576771",
    shippingProcessDate,
    orderStatus: "배송완료",
    shippingAttribute: "일반배송",
    fulfillmentCompany: "-",
    shippingMethod: "배송 없음",
    courierCompany: "우체국택배",
    trackingNumber: "2024071155576771",
    purchaseConfirmationExtensionStatus: "미연장",
  },
  {
    id: uniqueId(),
    name: "이영희",
    email: "younghee.lee@example.com",
    joinDate,
    paymentStatus: "연체",
    paymentAmount: 30000,
    nextPaymentDate,
    memberGrade: "베이직",
    address: "부산시 해운대구",
    avatar: "/static/avatar/002-girl.svg",
    productOrderNumber: "2024071155576772",
    orderNumber: "2024071155576772",
    shippingProcessDate,
    orderStatus: "배송중",
    shippingAttribute: "특급배송",
    fulfillmentCompany: "-",
    shippingMethod: "배송 없음",
    courierCompany: "우체국택배",
    trackingNumber: "2024071155576772",
    purchaseConfirmationExtensionStatus: "연장",
  },
  {
    id: uniqueId(),
    name: "박민준",
    email: "minjun.park@example.com",
    joinDate,
    paymentStatus: "정상",
    paymentAmount: 40000,
    nextPaymentDate,
    memberGrade: "베이직",
    address: "인천시 연수구",
    avatar: "/static/avatar/003-boy.svg",
    productOrderNumber: "2024071155576773",
    orderNumber: "2024071155576773",
    shippingProcessDate,
    orderStatus: "배송완료",
    shippingAttribute: "일반배송",
    fulfillmentCompany: "-",
    shippingMethod: "배송 없음",
    courierCompany: "우체국택배",
    trackingNumber: "2024071155576773",
    purchaseConfirmationExtensionStatus: "미연장",
  },
  {
    id: uniqueId(),
    name: "정수연",
    email: "suyeon.jung@example.com",
    joinDate,
    paymentStatus: "정상",
    paymentAmount: 60000,
    nextPaymentDate,
    memberGrade: "프리미엄",
    address: "대전시 유성구",
    avatar: "/static/avatar/004-woman.svg",
    productOrderNumber: "2024071155576774",
    orderNumber: "2024071155576774",
    shippingProcessDate,
    orderStatus: "배송중",
    shippingAttribute: "특급배송",
    fulfillmentCompany: "-",
    shippingMethod: "배송 없음",
    courierCompany: "우체국택배",
    trackingNumber: "2024071155576774",
    purchaseConfirmationExtensionStatus: "연장",
  },
  {
    id: uniqueId(),
    name: "최재현",
    email: "jaehyun.choi@example.com",
    joinDate,
    paymentStatus: "정상",
    paymentAmount: 55000,
    nextPaymentDate,
    memberGrade: "프리미엄",
    address: "광주시 서구",
    avatar: "/static/avatar/005-man-1.svg",
    productOrderNumber: "2024071155576775",
    orderNumber: "2024071155576775",
    shippingProcessDate,
    orderStatus: "배송완료",
    shippingAttribute: "일반배송",
    fulfillmentCompany: "-",
    shippingMethod: "배송 없음",
    courierCompany: "우체국택배",
    trackingNumber: "2024071155576775",
    purchaseConfirmationExtensionStatus: "미연장",
  },
  {
    id: uniqueId(),
    name: "송지원",
    email: "jiwon.song@example.com",
    joinDate,
    paymentStatus: "연체",
    paymentAmount: 35000,
    nextPaymentDate,
    memberGrade: "베이직",
    address: "대구시 수성구",
    avatar: "/static/avatar/006-woman-1.svg",
    productOrderNumber: "2024071155576776",
    orderNumber: "2024071155576776",
    shippingProcessDate,
    orderStatus: "배송중",
    shippingAttribute: "특급배송",
    fulfillmentCompany: "-",
    shippingMethod: "배송 없음",
    courierCompany: "우체국택배",
    trackingNumber: "2024071155576776",
    purchaseConfirmationExtensionStatus: "연장",
  },
  {
    id: uniqueId(),
    name: "강동훈",
    email: "donghoon.kang@example.com",
    joinDate,
    paymentStatus: "정상",
    paymentAmount: 45000,
    nextPaymentDate,
    memberGrade: "베이직",
    address: "울산시 남구",
    avatar: "/static/avatar/007-boy-1.svg",
    productOrderNumber: "2024071155576777",
    orderNumber: "2024071155576777",
    shippingProcessDate,
    orderStatus: "배송완료",
    shippingAttribute: "일반배송",
    fulfillmentCompany: "-",
    shippingMethod: "배송 없음",
    courierCompany: "우체국택배",
    trackingNumber: "2024071155576777",
    purchaseConfirmationExtensionStatus: "미연장",
  },
  {
    id: uniqueId(),
    name: "윤서연",
    email: "seoyeon.yoon@example.com",
    joinDate,
    paymentStatus: "정상",
    paymentAmount: 65000,
    nextPaymentDate,
    memberGrade: "프리미엄",
    address: "세종시 조치원읍",
    avatar: "/static/avatar/008-girl-1.svg",
    productOrderNumber: "2024071155576778",
    orderNumber: "2024071155576778",
    shippingProcessDate,
    orderStatus: "배송중",
    shippingAttribute: "특급배송",
    fulfillmentCompany: "-",
    shippingMethod: "배송 없음",
    courierCompany: "우체국택배",
    trackingNumber: "2024071155576778",
    purchaseConfirmationExtensionStatus: "연장",
  },
];

export const excelTableData = [
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Designer",
    team: "미통화",
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/001-man.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Callins",
    position: "Editor",
    team: "미통화",
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/002-girl.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Designer",
    team: "미통화",
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/003-boy.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Developer",
    team: "미통화",
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/004-woman.svg",
    dateOfBirth: format(new Date(2021, 10, 5), "MMM dd, yyyy"),
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Developer",
    team: "미통화",
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/005-man-1.svg",
    dateOfBirth: format(new Date(2021, 10, 5), "MMM dd, yyyy"),
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Designer",
    team: "미통화",
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/001-man.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Callins",
    position: "Editor",
    team: "미통화",
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/002-girl.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Designer",
    team: "미통화",
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/003-boy.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Developer",
    team: "미통화",
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/004-woman.svg",
    dateOfBirth: format(new Date(2021, 10, 5), "MMM dd, yyyy"),
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Developer",
    team: "미통화",
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/005-man-1.svg",
    dateOfBirth: format(new Date(2021, 10, 5), "MMM dd, yyyy"),
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Designer",
    team: "미통화",
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/001-man.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Callins",
    position: "Editor",
    team: "미통화",
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/002-girl.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Designer",
    team: "미통화",
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/003-boy.svg",
    dateOfBirth,
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Developer",
    team: "미통화",
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/004-woman.svg",
    dateOfBirth: format(new Date(2021, 10, 5), "MMM dd, yyyy"),
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
  {
    id: uniqueId(),
    name: "Lily Collins",
    position: "Developer",
    team: "미통화",
    experience: "3 years",
    phone: "+00578115245",
    avatar: "/static/avatar/005-man-1.svg",
    dateOfBirth: format(new Date(2021, 10, 5), "MMM dd, yyyy"),
    email: "Uilib@gmail.com",
    address: "Corner View, Sylhet",
    status: "Full Time",
  },
];

Mock.onGet("/api/tableData2/all").reply(() => {
  return [200, tableData2];
});
Mock.onPost("/api/tableData2/new").reply((config) => {
  const {
    name,
    username,
    email,
    position,
    team,
    experience,
    dateOfBirth,
    address,
    status,
  } = JSON.parse(config.data);
  const newObj = {
    name,
    email,
    username,
    position,
    team,
    experience,
    address,
    status,
    id: uniqueId(),
    avatar: "/static/avatar/012-woman-2.svg",
    dateOfBirth: format(new Date(dateOfBirth), "MMM dd, yyyy"),
  };
  tableData2.push(newObj);
  return [200, tableData2];
});
Mock.onPost("/api/tableData2/delete").reply((config) => {
  const { ids } = JSON.parse(config.data);
  const filterTable = tableData2.filter(
    (data, index) => data.id !== ids[index]
  );
  return [200, filterTable];
});

// ----------------------------

export const tableData3 = [
  {
    id: uniqueId(),
    team: "Alpha",
    leader: "Alice Johnson",
    phone: "+00123456789",
    domain: "google",
    marketer: 3,
    applier: 25,
  },
  {
    id: uniqueId(),
    team: "Beta",
    leader: "Bob Smith",
    phone: "+00198765432",
    domain: "amazon",
    marketer: 6,
    applier: 42,
  },
  {
    id: uniqueId(),
    team: "Gamma",
    leader: "Charlie Brown",
    phone: "+00111222333",
    domain: "facebook",
    marketer: 4,
    applier: 30,
  },
  {
    id: uniqueId(),
    team: "Delta",
    leader: "Diana Prince",
    phone: "+00112233445",
    domain: "apple",
    marketer: 7,
    applier: 55,
  },
  {
    id: uniqueId(),
    team: "Epsilon",
    leader: "Edward Collins",
    phone: "+00123242526",
    domain: "netflix",
    marketer: 2,
    applier: 19,
  },
  {
    id: uniqueId(),
    team: "Zeta",
    leader: "Fiona Graham",
    phone: "+00133252627",
    domain: "instagram",
    marketer: 8,
    applier: 60,
  },
  {
    id: uniqueId(),
    team: "Eta",
    leader: "George Harrison",
    phone: "+00144262728",
    domain: "twitter",
    marketer: 5,
    applier: 35,
  },
  {
    id: uniqueId(),
    team: "Theta",
    leader: "Hannah Abbott",
    phone: "+00155272829",
    domain: "linkedin",
    marketer: 3,
    applier: 20,
  },
  {
    id: uniqueId(),
    team: "Iota",
    leader: "Ian Fleming",
    phone: "+00166282930",
    domain: "tiktok",
    marketer: 7,
    applier: 48,
  },
  {
    id: uniqueId(),
    team: "Kappa",
    leader: "Judy Hopps",
    phone: "+00177293031",
    domain: "disney",
    marketer: 2,
    applier: 22,
  },
];
Mock.onGet("/api/tableData3/all").reply(() => {
  return [200, tableData3];
});
Mock.onPost("/api/tableData3/new").reply((config) => {
  const { team, leader, phone, marketer, applier } = JSON.parse(config.data);
  const newObj = {
    team,
    leader,
    phone,
    domain,
    marketer,
    applier,
    id: uniqueId(),
    avatar: "/static/avatar/012-woman-2.svg",
    dateOfBirth: format(new Date(dateOfBirth), "MMM dd, yyyy"),
  };
  tableData3.push(newObj);
  return [200, tableData3];
});
Mock.onPost("/api/tableData3/delete").reply((config) => {
  const { ids } = JSON.parse(config.data);
  const filterTable = tableData3.filter(
    (data, index) => data.id !== ids[index]
  );
  return [200, filterTable];
});

//=============================================================================

export const tableData4 = [
  {
    id: uniqueId(),
    name: "James Potter",
    totalApply: 9,
    beforeConsult: 9,
    onGoingConsult: 5,
    rejected: 1,
    3: 10,
    onProgress: 3,
    failed: 2,
    loan: 6,
    lab: 7,
    venture: 10,
    main: 4,
    reassessment: 2,
    totalSalary: 7,
  },
  {
    id: uniqueId(),
    name: "James Potter",
    totalApply: 8,
    beforeConsult: 4,
    onGoingConsult: 10,
    rejected: 8,
    succeed: 10,
    onProgress: 6,
    failed: 10,
    loan: 6,
    lab: 9,
    venture: 4,
    main: 7,
    reassessment: 6,
    totalSalary: 10,
  },
  {
    id: uniqueId(),
    name: "James Potter",
    totalApply: 8,
    beforeConsult: 3,
    onGoingConsult: 9,
    rejected: 6,
    succeed: 1,
    onProgress: 2,
    failed: 7,
    loan: 2,
    lab: 8,
    venture: 9,
    main: 1,
    reassessment: 7,
    totalSalary: 10,
  },
  {
    id: uniqueId(),
    name: "James Potter",
    totalApply: 4,
    beforeConsult: 6,
    onGoingConsult: 1,
    rejected: 10,
    succeed: 8,
    onProgress: 7,
    failed: 2,
    loan: 4,
    lab: 9,
    venture: 3,
    main: 5,
    reassessment: 2,
    totalSalary: 4,
  },
  {
    id: uniqueId(),
    name: "James Potter",
    totalApply: 3,
    beforeConsult: 3,
    onGoingConsult: 7,
    rejected: 2,
    succeed: 2,
    onProgress: 8,
    failed: 6,
    loan: 5,
    lab: 2,
    venture: 6,
    main: 3,
    reassessment: 9,
    totalSalary: 7,
  },
  {
    id: uniqueId(),
    name: "James Potter",
    totalApply: 9,
    beforeConsult: 9,
    onGoingConsult: 4,
    rejected: 8,
    succeed: 9,
    onProgress: 7,
    failed: 5,
    loan: 10,
    lab: 6,
    venture: 5,
    main: 9,
    reassessment: 7,
    totalSalary: 2,
  },
  {
    id: uniqueId(),
    name: "James Potter",
    totalApply: 8,
    beforeConsult: 5,
    onGoingConsult: 9,
    rejected: 9,
    succeed: 1,
    onProgress: 2,
    failed: 7,
    loan: 9,
    lab: 5,
    venture: 10,
    main: 6,
    reassessment: 7,
    totalSalary: 5,
  },
  {
    id: uniqueId(),
    name: "James Potter",
    totalApply: 2,
    beforeConsult: 8,
    onGoingConsult: 3,
    rejected: 7,
    succeed: 2,
    onProgress: 2,
    failed: 8,
    loan: 3,
    lab: 10,
    venture: 1,
    main: 4,
    reassessment: 10,
    totalSalary: 2,
  },
  {
    id: uniqueId(),
    name: "James Potter",
    totalApply: 5,
    beforeConsult: 9,
    onGoingConsult: 2,
    rejected: 9,
    succeed: 8,
    onProgress: 10,
    failed: 7,
    loan: 6,
    lab: 10,
    venture: 2,
    main: 1,
    reassessment: 7,
    totalSalary: 4,
  },
  {
    id: uniqueId(),
    name: "James Potter",
    totalApply: 7,
    beforeConsult: 10,
    onGoingConsult: 4,
    rejected: 10,
    succeed: 10,
    onProgress: 1,
    failed: 3,
    loan: 8,
    lab: 2,
    venture: 3,
    main: 10,
    reassessment: 1,
    totalSalary: 2,
  },
];
Mock.onGet("/api/tableData4/all").reply(() => {
  return [200, tableData3];
});
Mock.onPost("/api/tableData4/new").reply((config) => {
  const {
    name,
    totalApply,
    beforeConsult,
    onGoingConsult,
    rejected,
    succeed,
    onProgress,
    failed,
    loan,
    lab,
    venture,
    main,
    reassessment,
    totalSalary,
  } = JSON.parse(config.data);
  const newObj = {
    name,
    totalApply,
    beforeConsult,
    onGoingConsult,
    rejected,
    succeed,
    onProgress,
    failed,
    loan,
    lab,
    venture,
    main,
    reassessment,
    totalSalary,
    id: uniqueId(),
    avatar: "/static/avatar/012-woman-2.svg",
    dateOfBirth: format(new Date(dateOfBirth), "MMM dd, yyyy"),
  };
  tableData4.push(newObj);
  return [200, tableData4];
});
Mock.onPost("/api/tableData4/delete").reply((config) => {
  const { ids } = JSON.parse(config.data);
  const filterTable = tableData4.filter(
    (data, index) => data.id !== ids[index]
  );
  return [200, filterTable];
});
